module.exports = __webpack_public_path__ + "img/lcl-consol.34464334.png";